import {Pipe, PipeTransform} from '@angular/core';
import {Category} from '../../models/category.model';

@Pipe({
  name: 'filterByPrinceId'
})
export class FilterByPrinceIdPipe implements PipeTransform {

  transform(data: Category[], princeId: number): Category[] {
    return data.filter(category => {
      return category.PrinceId === princeId;
    }).sort((a, b) => {
      return a.DisplayOrder - b.DisplayOrder;
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/pipes/filterByPrinceId/filter-by-prince-id.pipe.ts